var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPlugConnected = function SvgPlugConnected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plug-connected_svg__plug-connected_svg__clip0_1479_24279)",
    stroke: "#089BEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 10l4.166 4.167-1.25 1.25a2.947 2.947 0 11-4.166-4.167L5.833 10zm8.334 0L10 5.832l1.25-1.25a2.946 2.946 0 114.167 4.166L14.167 10zM2.5 17.5l2.083-2.084M15.416 4.583L17.499 2.5M8.333 9.166l-1.667 1.667m4.167.833l-1.667 1.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plug-connected_svg__plug-connected_svg__clip0_1479_24279"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPlugConnected;